import axios from "axios"
import { useState } from "react"
import { useSelector } from "react-redux"
import { getAuth } from "../../store/features/authSlice"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

export const MyImagePickerInput = ({
  label,
  name,
  value,
  multiple,
  accept,
  onChange,
}) => {
  const auth = useSelector(getAuth)
  const [inputId, setInputId] = useState(String(Math.random()))

  const uploadFiles = (files) => {
    return new Promise(async (resolve, reject) => {
      if (!files) reject()

      try {
        // Cargar fotografía
        const form = new FormData()
        for (let key in files) {
          form.append("files", files[key])
        }
        console.log(form.get("files"))
        const { data } = await axios.post(
          `${API_ROUTE}/media/upload/cipmovil`,
          form,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: auth.data.jwtToken,
            },
          }
        )

        // Retornar los paths de las cargas
        resolve(data)
      } catch (err) {
        alert("Problema al cargar los archivos")
        reject()
      }
    })
  }

  const handleOnChange = async (files) => {
    try {
      const uploadedFiles = await uploadFiles(files)
      onChange({ target: { name, value: uploadedFiles[0].name } })
    } catch (err) {
      alert("No se pudo cargar el archivo")
    }
  }

  return (
    <>
      <label htmlFor={inputId}>
        <span>{label}:</span> <span>{value}</span>
        <input
          multiple={multiple}
          type="file"
          accept={accept}
          // style={{ display: "none" }}
          id={inputId}
          onChange={(event) => handleOnChange(event.target.files)}
        />
      </label>
    </>
  )
}
